import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';

@Component({
  selector: 'app-remarks-popup',
  templateUrl: './remarks-popup.component.html',
  styleUrls: ['./remarks-popup.component.scss'],
})
export class RemarksPopupComponent {
  comments: Comment[] = [];


  showForm = false;
  formData = {
    newCommentPic: '',
    newCommentText: '',
  };

  userList = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
    { label: 'KHGL - Khazar Guliyev', value: 'KHGL' }
  ];
  storedRemarkId: any;
  constructor(
    public dialogRef: MatDialogRef<RemarksPopupComponent>,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.loadData();
  }
  loadData() {
    this.storedRemarkId = localStorage.getItem('remarksId');
    let payload = {
      voyage_id: this.storedRemarkId,
    };
    this.dashboardService.getRemarks(payload).subscribe((data) => {
      this.comments = data.map((comment: any) => ({
        ...comment,
        timestamp: this.formatUTC(this.parseLocalDate(comment.timestamp))
      }));
    });
  }
  parseLocalDate(dateStr: string): Date | null {
    try {
      const [datePart, timePart] = dateStr.split(', ');
      const [yy, MM, dd] = datePart.split('/').map(Number);
      const year = 2000 + yy; // assuming year 20yy
      const [time, modifier] = timePart.split(' ');
      let [hours, minutes] = time.split(':').map(Number);
  
      if (modifier === 'PM' && hours < 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }
  
      return new Date(year, MM - 1, dd, hours, minutes);
    } catch (e) {
      console.error('Error parsing date:', e);
      return null;
    }
  }
  formatUTC(date: Date | null): string {
    if (!date) return '';
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
  }
  toggleForm() {
    this.showForm = !this.showForm;
  }

  onSubmit(confirmed: boolean) {
    const jsonString = JSON.stringify(this.formData);
    if (confirmed) {
      let payload = {
        voyage_id: this.storedRemarkId,
        pic:this.formData.newCommentPic,
        comment:this.formData.newCommentText
      }
      this.dashboardService.postRemarks(payload).subscribe(data=>{
        this.resetForm();
      })
    } else {
      this.dialogRef.close();
    }
  }

  resetForm() {
    this.formData.newCommentPic = '';
    this.formData.newCommentText = '';
    this.showForm = false;
    this.loadData()
  }
  getUserName(code: string): string {
    const user = this.userList.find(u => u.value === code);
    if (user && user.label.includes(' - ')) {
      return user.label.split(' - ')[1]; // Get only the name part
    }
    return code; // fallback
  }
  downloadComments() {
    if (!this.comments || this.comments.length === 0) {
      alert('No comments to download');
      return;
    }
  
    const headers = ['PIC', 'Timestamp', 'Comment'];
    const rows = this.comments.map(comment => [
      this.getUserName(comment.pic),
      new Date(comment.timestamp).toLocaleString(),
      comment.comment
    ]);
  
    const csvContent = [headers, ...rows]
      .map(e => e.map(item => `"${String(item).replace(/"/g, '""')}"`).join(','))
      .join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'comments.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  
  
}
interface Comment {
  pic: string;
  timestamp: string | Date;
  comment: string;
}

